enum PartType {
  Preparation = 'Preparation',
  Reaction = 'Reaction',
  Separation = 'Separation',
  Packaging = 'Packaging',
}

export default PartType;
